import * as React from 'react';
import { Messages } from '../../../codegen/Localize';
import { ContentClickedEventHandler } from '../../../common/telemetryEvents/types/ContentTelemetryTypes';
import { mouseUpFactory } from '../../../common/telemetryEvents/util/EventHandlerFactories';
import { imgUrl } from '../../../common/utilities/ImgUrl';
import { classes, cssClass } from '../../../style';
import { IUserInfo } from '../../../ts/models/IUserInfo';
import { telemetryConsumerWrapper } from '../../contexts/TelemetryConsumerWrapper';
import { ContentClickedTelemetryContext } from '../../contexts/TelemetryContexts';
import { SiteUrlsProps } from '../../selectors/SiteUrlsSelectors';
import { CardViewStyles } from './CardViewStyles';

const cssPrefix = 'DataRoleThumbnail';

const rootClass = cssClass(cssPrefix, 'root', {
  color: 'inherit',
  textDecoration: 'none',
  $nest: {
    '&:hover': {
      color: 'inherit',
      textDecoration: 'none',
    }
  }
});

const iconClass = cssClass(cssPrefix, 'icon', {
  backgroundImage: imgUrl('spaces_masthead_datarole.svg')
});

export interface DataRoleThumbnailProps extends SiteUrlsProps {
  readonly hoveredOrSelected: boolean;
  readonly navigateUrl: string;
  readonly owner: IUserInfo;
  readonly allowDragAndDrop: boolean;
}

export class DataRoleThumbnail extends React.Component<DataRoleThumbnailProps> {

  public render() {
    const containerClass = this.props.hoveredOrSelected ? CardViewStyles.CustomThumbnailHover : CardViewStyles.CustomThumbnail;
    return (
      <div>
      { telemetryConsumerWrapper(ContentClickedTelemetryContext.Consumer, (sendOpenContentTelemetry: ContentClickedEventHandler) =>
        <a
          onMouseUp={mouseUpFactory<HTMLAnchorElement>(sendOpenContentTelemetry)}
          className={classes(containerClass, rootClass)}
          href={this.props.navigateUrl}
          /**
           * If card reordering allowed, disable link dragging.
           * Otherwise, set `draggable` explicitly to undefined rather than true.
           * (When `draggable` is true, the browser-provided drag avatar looks too similar
           * to the reorder card feature's avatar, which may confuse users.)
           */
          draggable={this.props.allowDragAndDrop ? false : undefined}
        >
          <div>
            <div className={CardViewStyles.CustomThumbnailTopContainer}>
              <div className={classes(CardViewStyles.CustomThumbnailImg, iconClass)} title={Messages.dataRole()} />
            </div>
          </div>
        </a>
      )}
      </div>
    );
  }
}
